import { Stack } from '@fluentui/react';
import { Label } from 'office-ui-fabric-react';
import { IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataContact } from '../../../data/DataContact';
import { MaxLengths } from '../../../data/MaxLenghts.jsx';
import { Immocom } from '../../../specifique/immocom';
import { ComboBoxCivilite } from '../../ComboBox/ComboBoxCivilite';
import { ComboBoxEiffageSalarie } from '../../ComboBox/ComboBoxEiffageSalarie';
import { ComboBoxSituationActuelle } from '../../ComboBox/ComboBoxSituationActuelle';
import { ComboBoxSituationCivile } from '../../ComboBox/ComboBoxSituationCivile';
import { ComboBoxSourcing } from '../../ComboBox/ComboBoxSourcing';
import { EUIDatePicker } from '../../EUI/EUIDatePicker';
import { EUITextField } from '../../EUI/EUITextField';
import { EUIToggle } from '../../EUI/EUIToggle';
import { HintVerticalPosition, HintWrapper } from '../../Outils/HintWrapper';
import { PickerCPVille } from '../../Picker/PickerCPVille';
import './FicheContact.css';

export class BlocContact extends Component {

    static defaultProps = {
        appelDepuisReservation: false,
        contact: {},
        enfants: [],
        onChange: (event, newValue) => null,
        onDelayedChange: (contact, enfants) => null,
        peutModifierCivilite: false,
        peutModifierContactSa: false,
        peutModifierCpVille: false,
        peutModifierCritereDeDedoublonnement: false,
        peutModifierPrenom: false,
        idReservation: 0
    };

    static defaultState = {
        anneeNaissance: undefined,
        envoiIdentifiantsEffectue: false,
        envoiIdentifiantsErreur: undefined,
        envoiIdentifiantsTermine: false
    };

    constructor(props) {
        super(props);
        this.state = { ...BlocContact.defaultState };
    }

    _ajouterDateNaissanceEnfant = () => {

        const { anneeNaissance } = this.state;

        const dateNaissanceErreur = Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'datenaissance', anneeNaissance, false, 0) !== '';
        const dateNaissanceValide = anneeNaissance > 1900 && anneeNaissance <= new Date().getFullYear();

        if (!!anneeNaissance !== undefined && !dateNaissanceErreur && dateNaissanceValide) {
            const { contact, enfants, onDelayedChange } = this.props;
            const dateNaissance = new Date(anneeNaissance, 1, 1);

            let newEnfants = [...enfants];
            newEnfants.push(dateNaissance);

            this.setState(
                { anneeNaissance: undefined },
                () => onDelayedChange(contact, newEnfants)
            );
        }

    };

    _envoyerIdentifiantsAContactParMail = () => {

        this.setState({ envoiIdentifiantsEffectue: true });

        const { contact } = this.props;

        DataContact._envoyerIdentifiantsAContactParMail(contact.idContact).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const state = { envoiIdentifiantsTermine: true };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else this.setState({ envoiIdentifiantsErreur: responseFetch.messageRetour });
        });

    };

    _onDelayedChange = (key, value) => {
        const { contact, enfants, onDelayedChange } = this.props;
        const newContact = { ...contact, [key]: value, };
        onDelayedChange(newContact, enfants);
    };

    _onChangeCPVille = (ville, cp) => {
        const { contact, enfants, onDelayedChange } = this.props;
        let newContact = { ...contact };
        newContact.cp = cp;
        newContact.ville = ville;
        onDelayedChange(newContact, enfants);
    };

    _onSelectDate = (key, value) => {
        const date = Scriba.date().getChaineISOFromDate(value, true);
        this._onDelayedChange(key, date)
    };

    _supprimerDateNaissanceEnfant = (year) => {

        const { contact, enfants, onDelayedChange } = this.props;
        let newEnfants = [...enfants];

        const index = newEnfants.indexOf(year);
        if (index > -1) {
            newEnfants.splice(index, 1);
            onDelayedChange(contact, newEnfants);
        }

    };

    render = () => {
        const { appelDepuisReservation, idReservation, contact, enfants, onChange, peutModifierCivilite, peutModifierContactSa, peutModifierCpVille, peutModifierCritereDeDedoublonnement, peutModifierPrenom } = this.props;
        const { anneeNaissance, envoiIdentifiantsEffectue, envoiIdentifiantsErreur, envoiIdentifiantsTermine } = this.state;

        return <div className="ms-Grid mt-2">

            {!!appelDepuisReservation && idReservation === 0 && <MessageBar messageBarType={MessageBarType.warning}>Merci de compléter votre contact et de sélectionner un souhait pour passer à l'étape suivante.</MessageBar>}

            <div className="ms-Grid-row">

                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl9">

                    <div className="ms-Grid">

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg3 ms-xl2">
                                <ComboBoxCivilite
                                    disabled={!peutModifierContactSa && !peutModifierCivilite} // KP - 29/03/2023 - 2360 : autoriser la modification si champ non renseigné
                                    onChange={(event, option, index, value, item) => this._onDelayedChange("civilite", option.key)}
                                    required
                                    selectedKey={contact.civilite}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg5 uppercase">
                                <EUITextField
                                    disabled={!peutModifierContactSa}
                                    label="Nom"
                                    maxLength={MaxLengths.contact.nom}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("nom", newValue)}
                                    removeMultipleSpaces
                                    removeSpecialCharacters
                                    required
                                    value={contact.nom}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl5 capitalize">
                                <EUITextField
                                    disabled={!peutModifierContactSa && !peutModifierPrenom} // KP - 29/03/2023 - 2360 : autoriser la modification si champ non renseigné
                                    label="Prénom"
                                    maxLength={MaxLengths.contact.prenom}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("prenom", newValue)}
                                    removeMultipleSpaces
                                    removeSpecialCharacters
                                    required
                                    value={contact.prenom}
                                />
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                <EUITextField
                                    label="Adresse"
                                    maxLength={MaxLengths.contact.adresse}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("adresse", newValue)}
                                    value={contact.adresse}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                <EUITextField
                                    label="Complément d'adresse"
                                    maxLength={MaxLengths.contact.complementAdresse}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("complementAdresse", newValue)}
                                    value={contact.complementAdresse}
                                />
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                <PickerCPVille
                                    cp={contact.cp}
                                    disabled={!peutModifierCritereDeDedoublonnement && !peutModifierCpVille} // KP - 29/03/2023 - 2360 : autoriser la modification si champ non renseigné
                                    onChange={(idVilleAdm, idDeptAdm, idRegionAdm, cp, ville) => this._onChangeCPVille(ville, cp)}
                                    required
                                    villeAdministrative={contact.ville}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                <EUITextField
                                    label="Pays"
                                    maxLength={MaxLengths.contact.pays}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("pays", newValue)}
                                    value={contact.pays}
                                />
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUITextField
                                    label="Email"
                                    maxLength={MaxLengths.contact.email}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("email", newValue)}
                                    value={contact.email}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUITextField
                                    label="Tel mobile"
                                    maxLength={MaxLengths.contact.tel1}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("tel1", newValue)}
                                    value={contact.tel1}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUITextField
                                    label="Tel domicile"
                                    maxLength={MaxLengths.contact.tel2}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("tel2", newValue)}
                                    value={contact.tel2}
                                />
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUIDatePicker
                                    label="Date de naissance"
                                    onSelectDate={date => this._onSelectDate('datenaissance', date)}
                                    value={contact.datenaissance}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUITextField
                                    label="Lieu de naissance"
                                    maxLength={MaxLengths.contact.lieuNaissance}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("lieuNaissance", newValue)}
                                    value={contact.lieuNaissance}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUITextField
                                    label="Nationalité"
                                    maxLength={MaxLengths.contact.nationalite}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("nationalite", newValue)}
                                    value={contact.nationalite}
                                />
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUITextField
                                    label="Nom de jeune fille"
                                    maxLength={MaxLengths.contact.nomJeuneFille}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("nomJeuneFille", newValue)}
                                    value={contact.nomJeuneFille}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUIDatePicker
                                    label="Date de mariage"
                                    onSelectDate={date => this._onSelectDate('dateMariage', date)}
                                    value={contact.dateMariage}
                                />
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUITextField
                                    label="Profession"
                                    maxLength={MaxLengths.contact.profession}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("profession", newValue)}
                                    value={contact.profession}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUITextField
                                    label="Nom employeur"
                                    maxLength={MaxLengths.contact.nomEmployeur}
                                    onChange={onChange}
                                    onDelayedChange={(event, newValue) => this._onDelayedChange("nomEmployeur", newValue)}
                                    value={contact.nomEmployeur}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <HintWrapper
                                    content={<span>A remplir si cette information est nécessaire à la mise en place d'un financement ou d'un dispositif fiscal spécifique (Prêt à taux zéro, TVA au taux réduit…)</span>}
                                    verticalAlign={HintVerticalPosition.bottom}
                                    verticalOffset={5}
                                >
                                    <EUITextField
                                        afficherNbCaracteresRestants={false}
                                        label="Revenus annuels"
                                        maxLength={MaxLengths.contact.revenusAnnuels}
                                        onChange={onChange}
                                        onDelayedChange={(event, newValue) => this._onDelayedChange("revenusAnnuels", newValue)}
                                        value={contact.revenusAnnuels}
                                    />
                                </HintWrapper>
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <ComboBoxSituationActuelle
                                    onChange={(event, option, index, value, item) => this._onDelayedChange("situationActuelle", option.key)}
                                    selectedKey={contact.situationActuelle}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <ComboBoxSituationCivile
                                    onChange={(event, option, index, value, item) => this._onDelayedChange("situationCivile", option.key)}
                                    selectedKey={contact.situationCivile}
                                />
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <ComboBoxSourcing
                                    avecValeurDefaut={false}
                                    onChange={(event, option, index, value, item) => this._onDelayedChange("sourcing", option.key)}
                                    selectedKey={contact.sourcing}
                                />
                            </div>

                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <EUITextField
                                    disabled
                                    label="Propriétaire principal"
                                    value={contact.proprietaireEnCours}
                                />
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            {/* MG: - 26/09/2022 - 2148*/}
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <EUIToggle
                                    label="Collaborateur EI"
                                    checked={contact.collaborateurEI}
                                    onChange={(e, isChecked) => this._onDelayedChange("collaborateurEI", isChecked)}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg4">
                                <ComboBoxEiffageSalarie
                                    disabled={!contact.collaborateurEI}
                                    onChange={(event, option, index, value, item) => this._onDelayedChange("salarieEiffage", option.key)}
                                    selectedKey={contact.salarieEiffage}
                                />
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ">
                                <Label>Envoyer les identifiants au contact par mail</Label>
                                <Stack horizontal verticalAlign="center" toke={{ childrenGap: 5 }}>
                                    <PrimaryButton
                                        ariaLabel="Envoyer"
                                        disabled={!contact.idContact || !contact.email || envoiIdentifiantsEffectue}
                                        iconProps={{ iconName: 'Send' }}
                                        onClick={this._envoyerIdentifiantsAContactParMail}
                                        text="Envoyer"
                                    />
                                    {envoiIdentifiantsTermine && <span className="alert alert-success p-1 m-0 ml-1">Envoi effectué avec succès</span>}
                                    {envoiIdentifiantsErreur && <span className="alert alert-danger p-1 m-0 ml-1">{envoiIdentifiantsErreur}</span>}
                                </Stack>
                            </div>
                        </div>

                    </div>

                </div>

                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                    <HintWrapper
                        content={<span>A remplir si cette information est nécessaire à la mise en place d'un financement ou d'un dispositif fiscal spécifique (Prêt à taux zéro, TVA au taux réduit…)</span>}
                        verticalAlign={HintVerticalPosition.bottom}
                        verticalOffset={5}
                    >
                        <Label>Année de naissance des enfants</Label>
                    </HintWrapper>
                    <div className="blocEnfants">
                        <div className="divDateNaissance">
                            {enfants
                                .filter(enfant => !!enfant)
                                .map((value, index) =>
                                    <div key={index} className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12">
                                            <Label key={`labelDateNaissanceEnfant${index}`} className="labelDateNaissance">{Scriba.date().stringDateFormat(value, 'YYYY')}</Label>
                                            <IconButton key={`buttonDateNaissanceEnfant${index}`} iconProps={{ iconName: 'Delete' }} className="boutonSuppressionDateNaissance" onClick={() => this._supprimerDateNaissanceEnfant(value)} />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <Stack horizontal verticalAlign="end" tokens={{ childrenGap: 5 }}>
                            <Stack.Item grow={1}>
                                <EUITextField
                                    label="Ajouter un enfant"
                                    maxLength={MaxLengths.contact.dateNaissanceEnfant}
                                    onChange={(event, newValue) => this.setState({ anneeNaissance: newValue })}
                                    placeholder="Année de naissance"
                                    value={anneeNaissance}
                                />
                            </Stack.Item>
                            <PrimaryButton text="OK" disabled={!anneeNaissance || enfants.length >= 5} onClick={this._ajouterDateNaissanceEnfant} />
                        </Stack>
                    </div>
                </div>

            </div>

            {!!contact.idContact &&
                <div className="ms-Grid-row my-3">
                    <div className="ms-Grid-col ms-sm12">
                        Créé le {Scriba.date().stringDateFormatCourt(contact.creerLe)} par {contact.creerPar}
                    </div>
                    <div className="ms-Grid-col ms-sm12">
                        Modifié le {Scriba.date().stringDateFormatCourt(contact.modifierLe)} par {contact.modifierPar}
                    </div>
                </div>
            }

            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <label className="labelInformationsLegales">Les informations recueillies sont nécessaires à notre société pour traiter votre contact et de ce fait leur collecte est obligatoire. Ces informations feront l'objet d’un traitement informatique destiné à la gestion de clientèle et, éventuellement, à la prospection commerciale. Conformément à la Loi n° 78-17 du 6 Janvier 1978 relative à l’informatique, aux fichiers et aux libertés, modifiée, dite « informatique et libertés », vous bénéficiez d’un droit d’accès et de rectification aux informations qui vous concernent, que vous pouvez exercer en vous adressant à Eiffage Immobilier 11 place de l'Europe 78140 Vélizy-Villacoublay. Vous pouvez également, pour des motifs légitimes, vous opposer au traitement des données vous concernant. Vous êtes susceptibles de recevoir des offres commerciales de notre société pour des biens, produits ou services analogues à ceux que vous avez réservés. Si vous ne le souhaitez pas, cochez la case ci-contre.</label>
                </div>
                <div className="ms-Grid-col ms-sm12" name="divPrendreConnaissanceCNIL">
                    <EUIToggle
                        checked={contact.prendreConnaissanceCNIL}
                        label="J'ai pris connaissance des mentions CNIL"
                        onChange={(e, isChecked) => this._onDelayedChange("prendreConnaissanceCNIL", isChecked)}
                        required
                    />
                </div>
                <div className="ms-Grid-col ms-sm12">
                    <EUIToggle
                        checked={contact.souhaiteRecevoirOffres}
                        label="Je souhaite recevoir des offres commerciales"
                        onChange={(e, isChecked) => this._onDelayedChange("souhaiteRecevoirOffres", isChecked)}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12">
                    <EUIToggle
                        checked={contact.consentementCollecteDonneesPersonnelles}
                        label="Je consens au recueil de mes données personnelles par Eiffage Immobilier pour la gestion administrative et commerciale de mon dossier"
                        onChange={(e, isChecked) => this._onDelayedChange("consentementCollecteDonneesPersonnelles", isChecked)}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12">
                    <EUIToggle
                        checked={contact.consentementDiffusionDonneesPersonnelles}
                        label="Je souhaite être contacté à des fins d'enquêtes de satisfaction"
                        onChange={(e, isChecked) => this._onDelayedChange("consentementDiffusionDonneesPersonnelles", isChecked)}
                    />
                </div>
            </div>

        </div>;

    };

};